import React from 'react';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import BaseAutoComplete from '../base-auto-complete';
import { AddFunnelPropFromContext } from '../funnel-context';
import Copy from '@nib-components/copy';
import Link from '@nib-components/link';
import { Margin } from '@nib/layout';
import { WarningSystemIcon } from '@nib/icons';
import { StandardInfoBox } from '../info-box';
const LABELS = {
  ARHI: DEFAULT_LABELS.CURRENT_PROVIDER,
  IMAN: 'Current or last Australian health insurer',
  IWHI: 'Current or last Australian health insurer',
  ISHI: 'Current or last OSHC health insurer'
};
const HELP_TEXTS = {
  ARHI: ''
};
const OPTIONAL = {
  ARHI: false
};
export const CHANGE_COVER_LINK = 'https://go.nib.com.au/Y0LF/changecover';
export const NIB_FUND = 'nib Health Funds';
export const CurrentProvider = props => {
  const {
    label,
    help,
    id,
    options,
    suggestionList,
    width = 20,
    input,
    field,
    form,
    showMemberInfoBoxForNibFund,
    funnel = FUNNELS.ARHI,
    required,
    ...otherProps
  } = props;
  const renderNibMemberInfoBox = showMemberInfoBoxForNibFund && id && (field === null || field === void 0 ? void 0 : field.value) === NIB_FUND;
  return React.createElement(React.Fragment, null, React.createElement(BaseAutoComplete, {
    label: label || LABELS[funnel] || LABELS.ARHI,
    help: help || HELP_TEXTS[funnel] || HELP_TEXTS.ARHI,
    width: width,
    options: options,
    suggestionList: suggestionList,
    keys: ['value', 'text', 'aliases'],
    field: field,
    input: input,
    optional: OPTIONAL[funnel] || OPTIONAL.ARHI,
    funnel: funnel,
    id: id,
    form: form,
    ...otherProps
  }), renderNibMemberInfoBox && React.createElement(Margin, {
    top: 1
  }, React.createElement(StandardInfoBox, {
    withTip: true,
    icon: WarningSystemIcon
  }, React.createElement(Copy, null, "If you are a current nib member, you can", ' ', React.createElement(Link, {
    href: CHANGE_COVER_LINK,
    target: "_blank",
    rel: "noopener"
  }, "login"), ' ', "to compare or change your cover."))));
};
const CurrentProviderWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(CurrentProvider, {
  ...props
}));
export default CurrentProviderWithFunnel;